// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IModerationInfoSchema {
  /** Имеет проверенные документы **/
  hasVerifiedDocuments?: boolean;
  /** Название доверия к пользователю **/
  levelName?: string;
  /** Название степени доверия к пользователю **/
  levelOrderName?: ELevelOrderName;
}
export enum ELevelOrderName {
  /** Очень высокая степень доверия (level_number=4) **/
  'Gold' = 'gold',
  /** Высокая степень доверия (level_number=3) **/
  'Silver' = 'silver',
}
